import React, { useState, useEffect } from 'react';

import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { WithApp } from 'contexts/appContext';
import { wsFindBy } from 'services/WService.js';
import { wsGetAll } from 'services/WService';

export default WithApp(function ModalCuotaProvider(props) {
  const cuota = props.model;
  const customerPortfolioB = props.model;

  const [dataImport, setDataImport] = useState({});
  const [bPartnerSelect, setBPartnerSelect] = useState(undefined);
  const [dataChanging, setDataChanging] = useState(customerPortfolioB);
  const [coverages, setCoverages] = useState([]);

  function handleChange(field, value) {
    setDataChanging(prev => ({ ...prev, [field]: value }));
  }

  async function listCoverage() {
    let response = await wsGetAll('sale/cobertura-colgate');
    if (response.success) setCoverages(response.data);
  }
  
  useEffect(() => {
      if (customerPortfolioB.open) {
        if (!customerPortfolioB.id) listCoverage();
        setDataChanging(customerPortfolioB);
      }
    }, [customerPortfolioB.open]);

  useEffect(() => {
    if (cuota.open) setBPartnerSelect(undefined);
  }, [cuota.open]);

  useEffect(() => {
    if (dataImport?.success) {
      setBPartnerSelect({
        success: dataImport.success,
        customers: dataImport.data.map((item) => {
          return { description: item.DESCRIPCION };
        }),
        description: dataImport.nameFile
      });
    } else if (dataImport?.success === false) {
      setBPartnerSelect(undefined);
    }
  }, [dataImport]);

  useEffect(() => {
    if (bPartnerSelect?.id) {
      setDataImport({});
    }
  }, [bPartnerSelect]);

  return (
    <>
      <Modal
        title={`Nueva cuota de compra`}
        model={{ open: cuota.open }}
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        arrDataResponse
        entity='sale/cuota-compra-colgate'
        dataForce={{
          id_cobertura: dataChanging.id_cobertura,
        }}
      >
        <Autocomplete
          disableClearable
          options={coverages}
          getOptionLabel={(item) => `${item.description}`}
          renderInput={(params) => (
            <TextField {...params} label="Coberturas bimestrales" margin="normal" required />
          )}
          onChange={(e, item) => handleChange('id_cobertura', item?.id)}
          value={coverages.find(coverage => coverage.id === dataChanging.id_cobertura) || null}
        />
          <TextField
            label="Cuota"
            type="number"
            margin="normal"
            name="cuota"
            required
            fullWidth
          />
          <TextField
            label="Descripción de la cuota"
            type="text"
            margin="normal"
            name="description"
            required
            fullWidth
          />
      </Modal>
    </>
  );
});
